export const SITE_NAME = 'Discovery Digest'

export const APP_NAME = 'digest'

export const CONTENT_MODE = {
    DESKTOP: 'DESKTOP',
    MOBILE: 'MOBILE'
}